import React from 'react';
import '../../styles/tarjetaContenedor.css'
/**
 * Componente que muestra que se está procesando información
 * @returns Component Devuelve el componente con los elementos requeridos
 */
const Loader = () => {
    
    return(
        <div className="itemblog">
            <div>
                <h1 className='itemblogTitle'>Cargando</h1>
                <h1 className='info_itemblog'>Procesando información...</h1>
            </div>
        </div>
    )
}

export default Loader;